import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/globals.css';
import { applyTheme } from './lib/theme';

// Stamp the theme before first paint so there's no light/dark flash.
//
// PINNED TO LIGHT (console-hide-dark-mode-toggle, owner call 2026-07-30).
// Console dark mode is half-implemented: console-ui.css rethemes the --ui-*
// chrome, but tokens.css --color-surface has no dark variant, so ~488 bg-surface
// usages across 46 files stay light-locked and content renders white-on-white
// (console-modal-dark-mode-unstyled). Until that token gap is closed, dark is a
// broken surface rather than a choice, so we do not offer or infer it.
//
// Deliberately ignores BOTH the OS preference and any saved
// `bioweave_console_theme`: initialTheme() fell back to prefers-color-scheme,
// so merely removing the toggle would still hand OS-dark users the broken
// theme — and would TRAP anyone who had already saved 'dark', with no control
// left to escape it. lib/theme.ts is kept intact so restoring is a one-line
// revert here plus re-rendering <ThemeToggle/> in ConsoleLayout.
applyTheme('light');

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
